import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Team } from 'app/models/team';
import { Tag } from 'app/models/tag';
import { Form, FormGroup } from '@angular/forms';
import { TeamService } from 'app/services/team.service';
import { TagService } from 'app/services/tag.service'
import { PermissionService } from 'app/services/permission.service'
import { Permission, PermissionTargetPath } from 'app/models/permission';
import { formGroupPatchValueNullFriendly } from 'app/helpers/utils';
import { WorkflowTemplateService } from 'app/services/workflow-template.service';
import { WorkflowTemplate } from 'app/models/workflow-template';
import { AbstractPickedFile, CloudPickedFile } from 'app/models/picked-file';
import { finalize } from 'rxjs/operators';
@Component({
  selector: 'app-policy-rules',
  templateUrl: './policy-rules.component.html',
  styleUrls: ['./policy-rules.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PolicyRulesComponent implements OnInit {

  teams: Team[];
  tags: Tag[];
  workflows: WorkflowTemplate[];

  isNgSelectLoading: boolean = false;

  folders: [];

  userCreate: boolean = false;
  userUpdate: boolean = false;

  contactCreate: boolean = false;
  contactUpdate: boolean = false;

  storageCreate: boolean = false;
  storageUpdate: boolean = false;
  storageAccess: boolean = false;

  dashboardCreate: boolean = false;
  dashboardUpdate: boolean = false;
  dashboardAccess: boolean = false;

  workflowsCreate: boolean = false;
  workflowsUpdate: boolean = false;
  workflowsExecute: boolean = false;
  workflowsAnalytics: boolean = false;

  dataDelete: boolean = false;
  dataEdit: boolean = false;
  dataView: boolean = false;

  formsCreate: boolean = false;
  formsEdit: boolean = false;
  formsView: boolean = false;

  filesDelete: boolean = false;
  filesEdit: boolean = false;
  filesView: boolean = false;

  reportsCreate: boolean = false;
  tagsCreate: boolean = false;

  userCreateFormGroup: FormGroup;
  userUpdateFormGroup: FormGroup;

  //adminPermissions: string = 'none';
  teamPermissions: string = 'none';

  contactCreateFormGroup: FormGroup;
  contactUpdateFormGroup: FormGroup;

  storageCreateFormGroup: FormGroup;
  storageUpdateFormGroup: FormGroup;
  storageAccessFormGroup: FormGroup;

  dashboardCreateFormGroup: FormGroup;
  dashboardUpdateFormGroup: FormGroup;
  dashboardAccessFormGroup: FormGroup;

  workflowsCreateFormGroup: FormGroup;
  workflowsUpdateFormGroup: FormGroup;
  workflowsExecuteFormGroup: FormGroup;
  workflowsAnalyticsFormGroup: FormGroup;

  dataDeleteFormGroup: FormGroup;
  dataEditFormGroup: FormGroup;
  dataViewFormGroup: FormGroup;

  formsCreateFormGroup: FormGroup;
  formsEditFormGroup: FormGroup;
  formsViewFormGroup: FormGroup;

  filesDeleteFormGroup: FormGroup;
  filesEditFormGroup: FormGroup;
  filesViewFormGroup: FormGroup;

  folderPickedFor: string = '';

  @Input() isExternal: boolean = false;
  
  @Input() set permissions(permissions: Permission[])  {
    this.folderPickedFor = '';

    //this.adminPermissions = 'none';
    this.userCreate = false;
    this.userUpdate = false;
    this.contactCreate = false;
    this.contactUpdate = false;
    this.storageCreate = false;
    this.storageUpdate = false;
    this.storageAccess = false;
    this.workflowsCreate = false;
    this.workflowsUpdate = false;
    this.workflowsExecute = false;
    this.workflowsAnalytics = false;
    this.dashboardCreate = false;
    this.dashboardUpdate = false;
    this.dashboardAccess = false;
    this.dataDelete = false;
    this.dataEdit = false;
    this.dataView = false;
    this.formsCreate = false;
    this.formsEdit = false;
    this.formsView = false;
    this.filesDelete = false;
    this.filesEdit = false;
    this.filesView = false;
    this.reportsCreate = false;
    this.tagsCreate = false;

    permissions.forEach((p) => {
      if (p.name == 'super.admin.users.create') {
        this.userCreate = true;
        formGroupPatchValueNullFriendly(this.userCreateFormGroup, p);
      } else if (p.name == 'super.admin.users.create.update') {
        this.userUpdate = true;
        formGroupPatchValueNullFriendly(this.userUpdateFormGroup, p);
      } else if (p.name == 'super.admin.contacts.create') {
        this.contactCreate = true;
        formGroupPatchValueNullFriendly(this.contactCreateFormGroup, p);
      } else if (p.name == 'super.admin.contacts.create.update') {
        this.contactUpdate = true;
        formGroupPatchValueNullFriendly(this.contactUpdateFormGroup, p);
      } else if (p.name == 'super.admin.storage.create') {
        this.storageCreate = true;
        formGroupPatchValueNullFriendly(this.storageCreateFormGroup, p);
      } else if (p.name == 'super.admin.storage.create.update') {
        this.storageUpdate = true;
        formGroupPatchValueNullFriendly(this.storageUpdateFormGroup, p);
      } else if (p.name == 'super.admin.storage.create.update.list') {
        this.storageAccess = true;
        formGroupPatchValueNullFriendly(this.storageAccessFormGroup, p);
      } else if (p.name == 'super.admin.workflows.create') {
        this.workflowsCreate = true;
        formGroupPatchValueNullFriendly(this.workflowsCreateFormGroup, p);
      } else if (p.name == 'super.admin.workflows.create.update') {
        this.workflowsUpdate = true;
        formGroupPatchValueNullFriendly(this.workflowsUpdateFormGroup, p);
      } else if (p.name == 'super.admin.workflows.create.update.execute') {
        this.workflowsExecute = true;
        formGroupPatchValueNullFriendly(this.workflowsExecuteFormGroup, p);
      } else if (p.name == 'super.admin.workflows.analytics') {
        this.workflowsAnalytics = true;
        formGroupPatchValueNullFriendly(this.workflowsAnalyticsFormGroup, p);
      // } else if (p.name == 'super.admin.assign' || p.name == 'super.admin.assign.delete') {
      //   this.adminPermissions = p.name;
      } else if (p.name == 'super.admin.teams.create' || p.name == 'super.admin.teams.create.update') {
        this.teamPermissions = p.name;
      } else if (p.name == 'super.admin.dashboards.create') {
        this.dashboardCreate = true;
        formGroupPatchValueNullFriendly(this.dashboardCreateFormGroup, p);
      } else if (p.name == 'super.admin.dashboards.create.update') {
        this.dashboardUpdate = true;
        formGroupPatchValueNullFriendly(this.dashboardUpdateFormGroup, p);
      } else if (p.name == 'super.admin.dashboards.create.update.view') {
        this.dashboardAccess = true;
        formGroupPatchValueNullFriendly(this.dashboardAccessFormGroup, p);
      } else if (p.name == 'super.admin.data.delete') {
        this.dataDelete = true;
        formGroupPatchValueNullFriendly(this.dataDeleteFormGroup, p);
      } else if (p.name == 'super.admin.data.delete.update') {
        this.dataEdit = true;
        formGroupPatchValueNullFriendly(this.dataEditFormGroup, p);
      } else if (p.name == 'super.admin.data.delete.update.view') {
        this.dataView = true;
        formGroupPatchValueNullFriendly(this.dataViewFormGroup, p);
      } else if (p.name == 'super.admin.forms.create') {
        this.formsCreate = true;
        formGroupPatchValueNullFriendly(this.formsCreateFormGroup, p);
      } else if (p.name == 'super.admin.forms.create.update') {
        this.formsEdit = true;
        formGroupPatchValueNullFriendly(this.formsEditFormGroup, p);
      } else if (p.name == 'super.admin.forms.create.update.view') {
        this.formsView = true;
        formGroupPatchValueNullFriendly(this.formsViewFormGroup, p);
      } else if (p.name == 'super.admin.files.all.delete') {
        this.filesDelete = true;
        formGroupPatchValueNullFriendly(this.filesDeleteFormGroup, p);
      } else if (p.name == 'super.admin.files.all.delete.write') {
        this.filesEdit = true;
        formGroupPatchValueNullFriendly(this.filesEditFormGroup, p);
      } else if (p.name == 'super.admin.files.all.delete.write.read') {
        this.filesView = true;
        formGroupPatchValueNullFriendly(this.filesViewFormGroup, p);
      } else if (p.name == 'super.admin.reports.create') {
        this.reportsCreate = true;
      } else if (p.name == 'super.admin.misc.tags.create') {
        this.tagsCreate = true;
      }  

    });
  }

  get permissions(): Permission[] {
    let result: Permission[] = [];

    /** @todo when to make sure it's valid? */

    if (this.userCreate) {
      result.push(this.userCreateFormGroup.value);
    }

    if (this.userUpdate) {
      result.push(this.userUpdateFormGroup.value);
    }

    if (this.contactCreate) {
      result.push(this.contactCreateFormGroup.value);
    }

    if (this.contactUpdate) {
      result.push(this.contactUpdateFormGroup.value);
    }

    if (this.storageCreate) {
      result.push(this.storageCreateFormGroup.value);
    }

    if (this.storageUpdate) {
      result.push(this.storageUpdateFormGroup.value);
    }

    if (this.storageAccess) {
      result.push(this.storageAccessFormGroup.value);
    }

    if (this.workflowsCreate) {
      result.push(this.workflowsCreateFormGroup.value);
    }

    if (this.workflowsUpdate) {
      result.push(this.workflowsUpdateFormGroup.value);
    }

    if (this.workflowsExecute) {
      result.push(this.workflowsExecuteFormGroup.value);
    }

    if (this.workflowsAnalytics) {
      result.push(this.workflowsAnalyticsFormGroup.value);
    }

    // if (this.adminPermissions != 'none') {
    //   result.push({name:this.adminPermissions});
    // }

    if (this.teamPermissions != 'none') {
      result.push({name:this.teamPermissions});
    }

    if (this.dashboardCreate) {
      result.push(this.dashboardCreateFormGroup.value);
    }

    if (this.dashboardUpdate) {
      result.push(this.dashboardUpdateFormGroup.value);
    }

    if (this.dashboardAccess) {
      result.push(this.dashboardAccessFormGroup.value);
    }

    if (this.dataDelete) {
      result.push(this.dataDeleteFormGroup.value);
    }

    if (this.dataEdit) {
      result.push(this.dataEditFormGroup.value);
    }

    if (this.dataView) {
      result.push(this.dataViewFormGroup.value);
    }

    if (this.formsCreate) {
      result.push(this.formsCreateFormGroup.value);
    }

    if (this.formsEdit) {
      result.push(this.formsEditFormGroup.value);
    }

    if (this.formsView) {
      result.push(this.formsViewFormGroup.value);
    }

    if (this.filesDelete) {
      result.push(this.filesDeleteFormGroup.value);
    }

    if (this.filesEdit) {
      result.push(this.filesEditFormGroup.value);
    }

    if (this.filesView) {
      result.push(this.filesViewFormGroup.value);
    }

    if (this.reportsCreate) {
      result.push(this.permissionService.formGroup({name: "super.admin.reports.create", applies_to: "all"}).value);
    }

    if (this.tagsCreate) {
      result.push(this.permissionService.formGroup({name: "super.admin.misc.tags.create", applies_to: "all"}).value);
    }

    return result;
  }
  
  constructor(private permissionService: PermissionService, private teamService: TeamService, public tagService: TagService,
              private workflowTemplateService: WorkflowTemplateService) {
    teamService.getAll(false).subscribe(t => this.teams = t);
    tagService.currentTagsSubject.subscribe(t => this.tags = t);
    this.workflowTemplateService.getAll(true, false).subscribe(w => this.workflows = w);

    this.userCreateFormGroup = this.permissionService.formGroup({name: "super.admin.users.create", applies_to: "all"});
    this.userUpdateFormGroup = this.permissionService.formGroup({name: "super.admin.users.create.update", applies_to: "all"});

    this.contactCreateFormGroup = this.permissionService.formGroup({name: "super.admin.contacts.create", applies_to: "personal"});
    this.contactUpdateFormGroup = this.permissionService.formGroup({name: "super.admin.contacts.create.update", applies_to: "personal"});

    this.storageCreateFormGroup = this.permissionService.formGroup({name: "super.admin.storage.create", applies_to: "personal"});
    this.storageUpdateFormGroup = this.permissionService.formGroup({name: "super.admin.storage.create.update", applies_to: "personal"});
    this.storageAccessFormGroup = this.permissionService.formGroup({name: "super.admin.storage.create.update.list", applies_to: "personal"});

    this.workflowsCreateFormGroup = this.permissionService.formGroup({name: "super.admin.workflows.create", applies_to: "personal"});
    this.workflowsUpdateFormGroup = this.permissionService.formGroup({name: "super.admin.workflows.create.update", applies_to: "personal"});
    this.workflowsExecuteFormGroup = this.permissionService.formGroup({name: "super.admin.workflows.create.update.execute", applies_to: "personal"});
    this.workflowsAnalyticsFormGroup = this.permissionService.formGroup({name: "super.admin.workflows.analytics", applies_to: "all"});

    this.dashboardCreateFormGroup = this.permissionService.formGroup({name: "super.admin.dashboards.create", applies_to: "personal"});
    this.dashboardUpdateFormGroup = this.permissionService.formGroup({name: "super.admin.dashboards.create.update", applies_to: "personal"});
    this.dashboardAccessFormGroup = this.permissionService.formGroup({name: "super.admin.dashboards.create.update.view", applies_to: "personal"});

    this.dataDeleteFormGroup = this.permissionService.formGroup({name: "super.admin.data.delete", applies_to: "all"});
    this.dataEditFormGroup = this.permissionService.formGroup({name: "super.admin.data.delete.update", applies_to: "all"});
    this.dataViewFormGroup = this.permissionService.formGroup({name: "super.admin.data.delete.update.view", applies_to: "all"});

    this.formsCreateFormGroup = this.permissionService.formGroup({name: "super.admin.forms.create", applies_to: "all"});
    this.formsEditFormGroup = this.permissionService.formGroup({name: "super.admin.forms.create.update", applies_to: "all"});
    this.formsViewFormGroup = this.permissionService.formGroup({name: "super.admin.forms.create.update.view", applies_to: "all"});

    this.filesDeleteFormGroup = this.permissionService.formGroup({name: "super.admin.files.all.delete", applies_to: "all"});
    this.filesEditFormGroup = this.permissionService.formGroup({name: "super.admin.files.all.delete.write", applies_to: "all"});
    this.filesViewFormGroup = this.permissionService.formGroup({name: "super.admin.files.all.delete.write.read", applies_to: "all"});
   }

  ngOnInit(): void {
  }

  onAddItem (name: string) {
    return name;
  }

  onPickedFolder(e: AbstractPickedFile[]) {
    let cloudPickedFolder = e[0] as CloudPickedFile;

    if (this.folderPickedFor == 'super.admin.data.delete') {
      this.dataDeleteFormGroup.get('target_paths').setValue([...(this.dataDeleteFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.data.delete.update') {
      this.dataEditFormGroup.get('target_paths').setValue([...(this.dataEditFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.data.delete.update.view') {
      this.dataViewFormGroup.get('target_paths').setValue([...(this.dataViewFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.forms.create') {
      this.formsCreateFormGroup.get('target_paths').setValue([...(this.formsCreateFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.forms.create.update') {
      this.formsEditFormGroup.get('target_paths').setValue([...(this.formsEditFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.forms.create.update.view') {
      this.formsViewFormGroup.get('target_paths').setValue([...(this.formsViewFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.files.all.delete') {
      this.filesDeleteFormGroup.get('target_paths').setValue([...(this.filesDeleteFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.files.all.delete.write') {
      this.filesEditFormGroup.get('target_paths').setValue([...(this.filesEditFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    } else if (this.folderPickedFor == 'super.admin.files.all.delete.write.read') {
      this.filesViewFormGroup.get('target_paths').setValue([...(this.filesViewFormGroup.get('target_paths').value || []), {path: cloudPickedFolder.path} as PermissionTargetPath]);
    }
  }

  globalStorageFilter(storages: Storage[]) {
    return storages.filter(s => s.name == 'global');
  }

  onAddTag (name: string) {
    this.isNgSelectLoading = true;
    return this.tagService.add(name).pipe(finalize(()=>{
      this.isNgSelectLoading = false;
    })).toPromise();
  }

  workflowCompareWith(item, selected) {
    return item.name === selected.name;
  }
}
